import http from '@/utils/http'

export function getBranchSchools(params){
    return http.get('/branch_schools',{params})
}
export function getGradeStudentCountByBranch(params){
    return http.get('/getGradeStudentCountByBranch',{params})
}
export function getGradeStudentCountByTeacher(params){
    return http.get('/getGradeStudentCountByTeacher',{params})
}
export function addBranchSchools(data){
    return http.post('/branch_schools',data)
}
export function getBranchSchoolsDetail(id){
    return http.get(`/branch_schools/${id}`)
}
export function deleteBranchSchools(id){
    return http.delete(`/branch_schools/${id}`)
}
export function editBranchSchools(id,data){
    return http.put(`/branch_schools/${id}`,data)
}
export function getAreas(params){
    return http.get('/areas',{params})
}
export function getDistricts(params){
    return http.get('/districts',{params})
}
export function getCountries(params){
    return http.get('/countries',{params})
}
export function getAreaCodes(params){
    return http.get('/area_codes',{params})
}
export function getGrades(params){
    return http.get('/grades',{params})
}
export function editGrades(id,data){
    return http.put(`/grades/${id}`,data)
}
export function getWebFaqs(params){
    return http.get('/faqs',{params})
}
export function addWebFaqs(data){
    return http.post('/batch_edit_faqs',data)
}

export function getQuestionFeedbackCategories(params){
    return http.get('/question_feedback_categories',{params})
}
export function addQuestionFeedbackCategories(data){
    return http.post('/question_feedback_categories',data)
}
export function getQuestionFeedbackCategoriesDetail(id){
    return http.get(`/question_feedback_categories/${id}`)
}
export function deleteQuestionFeedbackCategories(id){
    return http.delete(`/question_feedback_categories/${id}`)
}
export function editQuestionFeedbackCategories(id,data){
    return http.put(`/question_feedback_categories/${id}`,data)
}



export function getQuestionFeedbacks(params){
    return http.get('/question_feedbacks',{params})
}
export function updateState(params){
    return http.put('/question_updateState',params)
}
export function getQuestionFeedbacksDetail(id){
    return http.get(`/question_feedbacks/${id}`)
}


export function getBanners(params){
    return http.get('/banners',{params})
}
export function addBatchEditBanners(data){
    return http.post('/batch_edit_banners',data)
}


export function getSubscriptionUpgradeDates(params){
    return http.get('/subscription_upgrade_dates',{params})
}
export function addSubscriptionUpgradeDates(data){
    return http.post('/subscription_upgrade_dates',data)
}


export function getStudentCodes(params){
    return http.get('/student_codes',{params})
}
export function addStudentCodes(data){
    return http.post('/student_codes',data)
}
export function getStudentCodesDetail(id){
    return http.get(`/student_codes/${id}`)
}
export function deleteStudentCodes(id){
    return http.delete(`/student_codes/${id}`)
}
export function editStudentCodes(id,data){
    return http.put(`/student_codes/${id}`,data)
}

export function importStudentCodes(data){
    return http.post('/import_student_codes',data)
}
export function getCards(params){
    return http.get('/cards',{params})
}
export function getCardTitle(){
    return http.get('/indexTitle')
}
export function getCardTitleList(){
    return http.get('/getCardTitleList')
}
export function saveCardTitle(data){
    return http.post('/saveCardTitle',data)
}
export function updateCardTitle(id,data){
    return http.put(`/updateCardTitle/${id}`,data)
}
export function getCardProperty(){
    return http.get('/indexProperty')
}
export function addCard(data){
    return http.post('/addCard',data)
}
export function editCard(id,data){
    return http.put(`/editCard/${id}`,data)
}
export function getCardsUser(params){
    return  http('/getCardsUser',{params})
}
export function getCardsNumUser(params){
    return  http('/getCardsNumUser',{params})
}
export function countLoginStudentNumber(params){
    return  http('/countLoginNumber',{params})
}
export function getEmailLogs(params){
    return  http('/getEmailLogs',{params})
}